export interface BahrainProduct {
  id: string;
  name: string;
  samplePrice: number;
  bulkPrice: number;
  moq: number;
  image: string;
  category: string;
}

export interface BahrainFactory {
  id: string;
  name: string;
  city: string;
  established: number;
  employees: string;
  verified: boolean;
  dropshipping: boolean;
  warehouseCountries?: string[];
  rating: number;
  responseRate: string;
  onTimeDelivery: string;
  productCount: number;
  categories: string[];
  description: string;
  logo: string;
  coverImage: string;
  products: BahrainProduct[];
}

export const bahrainFactories: BahrainFactory[] = [
  {
    id: "bf1",
    name: "Alba Aluminium Products Co.",
    city: "Manama",
    established: 2004,
    employees: "500–1000",
    verified: true,
    dropshipping: false,
    rating: 4.8,
    responseRate: "95%",
    onTimeDelivery: "94%",
    productCount: 760,
    categories: ["Aluminium", "Construction", "Industrial"],
    description: "World-class aluminium products manufacturer backed by Alba — one of the largest aluminium smelters globally. Producing premium aluminium sheets, profiles, and construction materials for global export.",
    logo: "https://public.readdy.ai/ai/img_res/bc4c6c1d52f54e07b82e8ed963560021.jpg",
    coverImage: "https://readdy.ai/api/search-image?query=Bahrain%20Manama%20aluminium%20factory%20production%20line%20workers%20industrial%20professional%20bright%20clean%20modern%20interior%20smelter&width=800&height=400&seq=bfc1&orientation=landscape",
    products: [
      {
        id: "bf1p1",
        name: "Aluminium Composite Panels (10 sheets)",
        samplePrice: 180,
        bulkPrice: 65,
        moq: 20,
        category: "Construction",
        image: "https://readdy.ai/api/search-image?query=aluminium%20composite%20panels%2010%20sheets%20construction%20material%20white%20background%20product%20photography%20professional%20industrial%20building&width=400&height=400&seq=bf1p1&orientation=squarish",
      },
      {
        id: "bf1p2",
        name: "Extruded Aluminium Profiles (6m)",
        samplePrice: 95,
        bulkPrice: 36,
        moq: 30,
        category: "Aluminium",
        image: "https://readdy.ai/api/search-image?query=extruded%20aluminium%20profiles%206m%20industrial%20metal%20construction%20material%20white%20background%20product%20photography%20professional&width=400&height=400&seq=bf1p2&orientation=squarish",
      },
      {
        id: "bf1p3",
        name: "Aluminium Ingots 99.7% Pure (25kg)",
        samplePrice: 145,
        bulkPrice: 55,
        moq: 50,
        category: "Industrial",
        image: "https://readdy.ai/api/search-image?query=aluminium%20ingots%2099.7%20pure%2025kg%20industrial%20metal%20white%20background%20product%20photography%20professional%20clean%20manufacturing&width=400&height=400&seq=bf1p3&orientation=squarish",
      },
    ],
  },
  {
    id: "bf2",
    name: "Bahrain Pearl Jewellery House",
    city: "Muharraq",
    established: 2009,
    employees: "50–100",
    verified: true,
    dropshipping: true,
    warehouseCountries: ["Bahrain", "UAE", "Saudi Arabia", "UK", "USA", "Japan"],
    rating: 4.9,
    responseRate: "98%",
    onTimeDelivery: "97%",
    productCount: 520,
    categories: ["Jewellery", "Luxury", "Pearls"],
    description: "Bahrain's finest pearl and luxury jewellery manufacturer, continuing the island's legendary pearl diving heritage. Crafting authentic natural pearl jewellery and gold pieces for global wholesale buyers.",
    logo: "https://readdy.ai/api/search-image?query=luxury%20pearl%20jewellery%20company%20logo%20gold%20pearl%20emblem%20white%20background%20Muharraq%20Bahrain%20corporate%20identity%20elegant%20minimalist&width=80&height=80&seq=bfl2&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=Bahrain%20Muharraq%20pearl%20jewellery%20workshop%20craftsmen%20luxury%20pearls%20gold%20pieces%20elegant%20interior%20professional%20bright%20clean&width=800&height=400&seq=bfc2&orientation=landscape",
    products: [
      {
        id: "bf2p1",
        name: "Natural Bahraini Pearl Necklace",
        samplePrice: 680,
        bulkPrice: 480,
        moq: 3,
        category: "Pearls",
        image: "https://readdy.ai/api/search-image?query=natural%20Bahraini%20pearl%20necklace%20luxury%20elegant%20white%20background%20product%20photography%20premium%20jewellery%20Middle%20East&width=400&height=400&seq=bf2p1&orientation=squarish",
      },
      {
        id: "bf2p2",
        name: "18K Gold Pearl Drop Earrings",
        samplePrice: 320,
        bulkPrice: 220,
        moq: 5,
        category: "Jewellery",
        image: "https://readdy.ai/api/search-image?query=18K%20gold%20pearl%20drop%20earrings%20luxury%20elegant%20white%20background%20product%20photography%20premium%20jewellery%20Bahrain&width=400&height=400&seq=bf2p2&orientation=squarish",
      },
      {
        id: "bf2p3",
        name: "Pearl & Gold Bracelet Set",
        samplePrice: 450,
        bulkPrice: 310,
        moq: 4,
        category: "Luxury",
        image: "https://readdy.ai/api/search-image?query=pearl%20gold%20bracelet%20set%20luxury%20elegant%20white%20background%20product%20photography%20premium%20jewellery%20Bahrain%20Middle%20East&width=400&height=400&seq=bf2p3&orientation=squarish",
      },
    ],
  },
  {
    id: "bf3",
    name: "Gulf Petrochemical Industries",
    city: "Sitra",
    established: 2000,
    employees: "200–500",
    verified: true,
    dropshipping: false,
    rating: 4.7,
    responseRate: "92%",
    onTimeDelivery: "93%",
    productCount: 640,
    categories: ["Chemicals", "Plastics", "Industrial"],
    description: "Major petrochemical manufacturer in Sitra Industrial Area. Producing industrial-grade chemicals, polymers, and specialty plastics for global manufacturing and packaging industries.",
    logo: "https://readdy.ai/api/search-image?query=petrochemical%20company%20logo%20gold%20molecule%20emblem%20white%20background%20Sitra%20Bahrain%20corporate%20identity%20professional%20industrial&width=80&height=80&seq=bfl3&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=Sitra%20Bahrain%20petrochemical%20industrial%20plant%20production%20professional%20bright%20clean%20modern%20aerial%20view%20factory%20chemicals&width=800&height=400&seq=bfc3&orientation=landscape",
    products: [
      {
        id: "bf3p1",
        name: "HDPE Polymer Granules 25kg",
        samplePrice: 58,
        bulkPrice: 20,
        moq: 100,
        category: "Plastics",
        image: "https://readdy.ai/api/search-image?query=HDPE%20polymer%20granules%2025kg%20bag%20industrial%20white%20background%20product%20photography%20professional%20clean%20manufacturing%20plastics&width=400&height=400&seq=bf3p1&orientation=squarish",
      },
      {
        id: "bf3p2",
        name: "Industrial Solvent Cleaner 200L",
        samplePrice: 260,
        bulkPrice: 98,
        moq: 5,
        category: "Chemicals",
        image: "https://readdy.ai/api/search-image?query=industrial%20solvent%20cleaner%20200L%20drum%20chemical%20white%20background%20product%20photography%20professional%20clean%20industrial%20storage&width=400&height=400&seq=bf3p2&orientation=squarish",
      },
      {
        id: "bf3p3",
        name: "PVC Compound Pellets 20kg",
        samplePrice: 42,
        bulkPrice: 15,
        moq: 200,
        category: "Plastics",
        image: "https://readdy.ai/api/search-image?query=PVC%20compound%20pellets%2020kg%20bag%20industrial%20white%20background%20product%20photography%20professional%20clean%20manufacturing%20plastics&width=400&height=400&seq=bf3p3&orientation=squarish",
      },
    ],
  },
  {
    id: "bf4",
    name: "Bahrain Luxury Dates & Sweets",
    city: "Riffa",
    established: 2012,
    employees: "50–100",
    verified: true,
    dropshipping: true,
    warehouseCountries: ["Bahrain", "UAE", "Saudi Arabia", "UK", "USA", "Germany"],
    rating: 4.8,
    responseRate: "96%",
    onTimeDelivery: "95%",
    productCount: 290,
    categories: ["Food & Beverage", "Luxury", "Gift Sets"],
    description: "Premium Bahraini dates and traditional sweets manufacturer in Riffa. Producing luxury halal-certified date gift boxes, Arabic sweets, and corporate hampers for global retail and dropshipping.",
    logo: "https://readdy.ai/api/search-image?query=luxury%20dates%20sweets%20company%20logo%20gold%20palm%20emblem%20white%20background%20Riffa%20Bahrain%20food%20corporate%20identity%20elegant&width=80&height=80&seq=bfl4&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=Bahrain%20Riffa%20luxury%20dates%20sweets%20factory%20production%20packaging%20elegant%20interior%20professional%20bright%20clean%20modern&width=800&height=400&seq=bfc4&orientation=landscape",
    products: [
      {
        id: "bf4p1",
        name: "Bahraini Royal Dates Gift Box 1kg",
        samplePrice: 62,
        bulkPrice: 22,
        moq: 20,
        category: "Food & Beverage",
        image: "https://readdy.ai/api/search-image?query=Bahraini%20royal%20dates%20gift%20box%201kg%20luxury%20gold%20packaging%20white%20background%20product%20photography%20elegant%20food%20premium&width=400&height=400&seq=bf4p1&orientation=squarish",
      },
      {
        id: "bf4p2",
        name: "Arabic Halwa Assortment Box 500g",
        samplePrice: 48,
        bulkPrice: 18,
        moq: 30,
        category: "Food & Beverage",
        image: "https://readdy.ai/api/search-image?query=Arabic%20halwa%20assortment%20box%20500g%20luxury%20traditional%20sweet%20gold%20packaging%20white%20background%20product%20photography%20premium&width=400&height=400&seq=bf4p2&orientation=squarish",
      },
      {
        id: "bf4p3",
        name: "Premium Corporate Gift Hamper",
        samplePrice: 110,
        bulkPrice: 42,
        moq: 10,
        category: "Gift Sets",
        image: "https://readdy.ai/api/search-image?query=premium%20corporate%20gift%20hamper%20luxury%20gold%20packaging%20dates%20sweets%20white%20background%20product%20photography%20elegant%20Bahrain&width=400&height=400&seq=bf4p3&orientation=squarish",
      },
    ],
  },
  {
    id: "bf5",
    name: "Manama Textile & Fashion Co.",
    city: "Manama",
    established: 2017,
    employees: "50–100",
    verified: false,
    dropshipping: true,
    warehouseCountries: ["Bahrain", "UAE", "Saudi Arabia", "Turkey"],
    rating: 4.3,
    responseRate: "83%",
    onTimeDelivery: "86%",
    productCount: 240,
    categories: ["Textiles", "Clothing", "Abayas"],
    description: "Modern fashion and textile manufacturer in Manama producing designer abayas, traditional Gulf clothing, and custom uniforms with competitive pricing and dropshipping support.",
    logo: "https://readdy.ai/api/search-image?query=fashion%20textile%20company%20logo%20gold%20needle%20emblem%20white%20background%20Manama%20Bahrain%20clothing%20manufacturing%20corporate%20identity&width=80&height=80&seq=bfl5&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=Manama%20Bahrain%20fashion%20textile%20factory%20sewing%20machines%20workers%20abaya%20clothing%20production%20professional%20bright%20interior%20modern&width=800&height=400&seq=bfc5&orientation=landscape",
    products: [
      {
        id: "bf5p1",
        name: "Designer Abaya with Embroidery",
        samplePrice: 85,
        bulkPrice: 32,
        moq: 20,
        category: "Abayas",
        image: "https://readdy.ai/api/search-image?query=designer%20abaya%20with%20embroidery%20elegant%20black%20luxury%20white%20background%20product%20photography%20premium%20clothing%20Middle%20East%20Bahrain&width=400&height=400&seq=bf5p1&orientation=squarish",
      },
      {
        id: "bf5p2",
        name: "Traditional Bahraini Thobe (White)",
        samplePrice: 52,
        bulkPrice: 20,
        moq: 30,
        category: "Clothing",
        image: "https://readdy.ai/api/search-image?query=traditional%20Bahraini%20thobe%20white%20elegant%20garment%20white%20background%20product%20photography%20premium%20clothing%20Middle%20East&width=400&height=400&seq=bf5p2&orientation=squarish",
      },
      {
        id: "bf5p3",
        name: "Luxury Silk Shayla Scarf",
        samplePrice: 38,
        bulkPrice: 14,
        moq: 50,
        category: "Textiles",
        image: "https://readdy.ai/api/search-image?query=luxury%20silk%20shayla%20scarf%20elegant%20fabric%20white%20background%20product%20photography%20premium%20Middle%20East%20fashion%20Bahrain&width=400&height=400&seq=bf5p3&orientation=squarish",
      },
    ],
  },
  {
    id: "bf6",
    name: "Bahrain Smart Tech Hub",
    city: "Manama",
    established: 2020,
    employees: "50–100",
    verified: true,
    dropshipping: true,
    warehouseCountries: ["Bahrain", "UAE", "Saudi Arabia", "UK", "USA", "Singapore"],
    rating: 4.7,
    responseRate: "95%",
    onTimeDelivery: "94%",
    productCount: 380,
    categories: ["Electronics", "Smart Home", "FinTech Devices"],
    description: "Innovative smart technology startup in Manama's financial district. Producing smart payment devices, IoT home systems, and consumer electronics for the Gulf region and global markets.",
    logo: "https://readdy.ai/api/search-image?query=smart%20tech%20fintech%20company%20logo%20gold%20circuit%20emblem%20white%20background%20Manama%20Bahrain%20technology%20corporate%20identity%20modern&width=80&height=80&seq=bfl6&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=Manama%20Bahrain%20smart%20tech%20hub%20office%20production%20IoT%20devices%20electronics%20professional%20bright%20modern%20interior%20fintech&width=800&height=400&seq=bfc6&orientation=landscape",
    products: [
      {
        id: "bf6p1",
        name: "Smart POS Payment Terminal",
        samplePrice: 145,
        bulkPrice: 58,
        moq: 10,
        category: "FinTech Devices",
        image: "https://readdy.ai/api/search-image?query=smart%20POS%20payment%20terminal%20modern%20sleek%20design%20white%20background%20product%20photography%20professional%20tech%20fintech%20device&width=400&height=400&seq=bf6p1&orientation=squarish",
      },
      {
        id: "bf6p2",
        name: "Smart Home Gateway Hub",
        samplePrice: 98,
        bulkPrice: 38,
        moq: 20,
        category: "Smart Home",
        image: "https://readdy.ai/api/search-image?query=smart%20home%20gateway%20hub%20modern%20sleek%20design%20white%20background%20product%20photography%20professional%20tech%20IoT%20device%20Bahrain&width=400&height=400&seq=bf6p2&orientation=squarish",
      },
      {
        id: "bf6p3",
        name: "Wireless Smart Door Lock",
        samplePrice: 78,
        bulkPrice: 30,
        moq: 25,
        category: "Smart Home",
        image: "https://readdy.ai/api/search-image?query=wireless%20smart%20door%20lock%20modern%20sleek%20design%20white%20background%20product%20photography%20professional%20tech%20security%20home%20device&width=400&height=400&seq=bf6p3&orientation=squarish",
      },
    ],
  },
];
